import { BADGE_VARIANTS } from './constants';
import { Badge } from './Badge';
import { BadgeProps } from './types';

export type BadgeNoVariantProps = Omit<BadgeProps, 'variant'>;

// Status Badges
export const DraftBadge = (props: BadgeNoVariantProps) => (
  <Badge variant={BADGE_VARIANTS.DRAFT} {...props} />
);
export const ReadyBadge = (props: BadgeNoVariantProps) => (
  <Badge variant={BADGE_VARIANTS.READY} {...props} />
);
export const ScheduledBadge = (props: BadgeNoVariantProps) => (
  <Badge variant={BADGE_VARIANTS.SCHEDULED} {...props} />
);
export const RecurringBadge = (props: BadgeNoVariantProps) => (
  <Badge variant={BADGE_VARIANTS.RECURRING} {...props} />
);
export const RunningBadge = (props: BadgeNoVariantProps) => (
  <Badge variant={BADGE_VARIANTS.RUNNING} {...props} />
);
export const FinishedBadge = (props: BadgeNoVariantProps) => (
  <Badge variant={BADGE_VARIANTS.FINISHED} {...props} />
);
export const RecalledBadge = (props: BadgeNoVariantProps) => (
  <Badge variant={BADGE_VARIANTS.RECALL} {...props} />
);
export const AbortedBadge = (props: BadgeNoVariantProps) => (
  <Badge variant={BADGE_VARIANTS.ABORTED} {...props} />
);

// Access Badges
export const BossBadge = (props: BadgeNoVariantProps) => (
  <Badge variant={BADGE_VARIANTS.BOSS} {...props} />
);

// Utility Badges
export const PositiveBadge = (props: BadgeNoVariantProps) => (
  <Badge variant={BADGE_VARIANTS.POSITIVE} {...props} />
);
export const WarningBadge = (props: BadgeNoVariantProps) => (
  <Badge variant={BADGE_VARIANTS.WARNING} {...props} />
);
export const NegativeBadge = (props: BadgeNoVariantProps) => (
  <Badge variant={BADGE_VARIANTS.NEGATIVE} {...props} />
);
export const InfoBadge = (props: BadgeNoVariantProps) => (
  <Badge variant={BADGE_VARIANTS.INFO} {...props} />
);
export const NeutralBadge = (props: BadgeNoVariantProps) => (
  <Badge variant={BADGE_VARIANTS.NEUTRAL} {...props} />
);
export const InvertedBadge = (props: BadgeNoVariantProps) => (
  <Badge variant={BADGE_VARIANTS.INVERTED} {...props} />
);

// Counter Badges
export const CounterBadge = (props: BadgeNoVariantProps) => (
  <Badge variant={BADGE_VARIANTS.COUNTER} {...props} />
);

export const CounterSubtleBadge = (props: BadgeNoVariantProps) => (
  <Badge variant={BADGE_VARIANTS.COUNTER_SUBTLE} {...props} />
);

export const CounterErrorBadge = (props: BadgeNoVariantProps) => (
  <Badge variant={BADGE_VARIANTS.COUNTER_ERROR} {...props} />
);

// AI Badge

export const AIBadge = (props: BadgeNoVariantProps) => (
  <Badge variant={BADGE_VARIANTS.AI} {...props} />
);

// BETA Badge

export const BetaBadge = (props: BadgeNoVariantProps) => (
  <Badge variant={BADGE_VARIANTS.BETA} {...props} />
);

// Meta Badges

export const InAppealBadge = (props: BadgeNoVariantProps) => (
  <Badge variant={BADGE_VARIANTS.IN_APPEAL} {...props} />
);

export const UnknownBadge = (props: BadgeNoVariantProps) => (
  <Badge variant={BADGE_VARIANTS.UNKNOWN} {...props} />
);

// Data Sync Destination Badges
export const PendingBadge = (props: BadgeNoVariantProps) => (
  <Badge variant={BADGE_VARIANTS.PENDING} {...props} />
);
export const ArchivedBadge = (props: BadgeNoVariantProps) => (
  <Badge variant={BADGE_VARIANTS.ARCHIVED} {...props} />
);
export const EnabledBadge = (props: BadgeNoVariantProps) => (
  <Badge variant={BADGE_VARIANTS.ENABLED} {...props} />
);
export const NeedsReviewBadge = (props: BadgeNoVariantProps) => (
  <Badge variant={BADGE_VARIANTS.NEEDS_REVIEW} {...props} />
);
export const DisabledBadge = (props: BadgeNoVariantProps) => (
  <Badge variant={BADGE_VARIANTS.DISABLED} {...props} />
);
